import React from 'react';
import { Popup, ToolbarItem } from "devextreme-react/popup";

const MessagePopup = ({ popupMessageContent,isMessagePopupVisible,setMessagePopupVisibility,type}) => {


    const handleDismiss = () => {
        setMessagePopupVisibility(false);
        // onDismiss(); // Call the onDismiss callback passed from the parent component
      };

      
// option for another button-

//   const switchButtonOptions = {
//     text: " יציאה מהמסך הנוכחי",
//     stylingMode: "contained",
//     onClick: switchButtonFunc,
//   };

const closeButtonOptions = {
    text: "אשר",
    stylingMode: "outlined",
    onClick: handleDismiss,
  };

  return (
    <>
      {isMessagePopupVisible && (
        <div 
        style={{ padding: '10px', color: 'white', margin:"10px" }}
        >
          
          <Popup
          visible={isMessagePopupVisible}
          showTitle={true}
          title="סטטוס תגובה"
          showCloseButton={false}
          width={300}
          height={180}

        >
          {popupMessageContent}
          <ToolbarItem
            widget="dxButton"
            toolbar="bottom"
            location="after"
            options={closeButtonOptions}
          />
          {/*  //option for another button
          
          <ToolbarItem
            widget="dxButton"
            toolbar="bottom"
            location="center"
            options={switchButtonOptions}
          /> */}
        </Popup>
        </div>
      )}
    </>
  );
};

export default MessagePopup;